"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Represents one transaction of system.
 *
 * <p>
 * Represents information about number of units (product instances) added to, or removed from, a site, on given day or set of days. That is,
 * one record usually represents aggregation of several units sold, stocked in, etc.
 * </p>
 *
 * <p>
 * Positive transactions (amount > 0) increase the value of goods at the site (e.g. stock in). Negative transactions decrease
 * value (e.g. sold products). Transaction type usually determines the sign of the transaction, but there are exceptions (e.g.
 * positive transaction of type sale represents cancellation of sale transaction).
 * </p>
 *
 * <p>
 * The sign of price values (costValue, saleValueWithVat, vatValue) corresponds to the sign of the amount.
 * </p>
 *
 * <p>
 * <b>
 * It is important to note that the sales transactions represent the release of items from stock, the quantity and the price
 * are negative, the unit price value is then computed as sale value with vat / amount and is positive.
 * </b>
 * </p>
 *
 * <p>
 * <b>
 * Not related to LOG-3930, but external ids for all referenced data has been added. All references to internal ids will be removed
 * in future, more precisely after the corresponding implementation will be refactored to use external ids.
 * </b>
 * </p>
 *
 * TODO We should create new attribute, which would represent conjunction of product id and site id. External ids would be better, because
 * TODO of their length (smaller than _id). Within application use cases, we should not map all product ids and site ids, instead, we should
 * TODO create single set of product,site strings, and query data by them.
 *
 * @author VRu
 */


var Transaction =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(Transaction, _StateDomainObject_1$);

  /**
   * @param id
   * @param externalId external id of single transaction
   * @param productId id of product, mandatory field, mixed products are not allowed in aggregations
   *        TODO attr will be removed when application starts to work with transactions using external ids
   * @param productExtId refers to {@link Product.externalId product's external id}.
   * @param siteId id of site, mandatory field, mixed sites are not allowed in aggregations
   *        TODO attr will be removed when application starts to work with transactions using external ids
   * @param siteExtId refers to {@link InternalSite.externalId site's external id}.
   * @param date transactions issued within this day
   * @param dateFrom all individual transactions took place after this moment
   *        TODO attr will be removed when application starts using {@link Transaction.date}
   * @param dateTo all individual transactions took place before this moment
   *        TODO attr will be removed when application starts using {@link Transaction.date}
   * @param transactionTypeId id of transaction type code book.
   *        TODO attr will be removed when application starts to work with transactions using external ids. But code books will be still
   *        TODO ...created.
   * @param transactionTypeExtId reference to external id of transaction type code book
   * @param promotionId reference to promotion to which transaction is related to (if any)
   *        TODO attr will be removed when application starts to work with transactions using external ids
   * @param promotionExtId refers to {@link Promotion.externalId promotion's external id} if transaction is related to a promotion
   * @param asPromotion product is sold as promotion (e.g. due to expiration), but does not have link to promotion
   * @param posAction true means transaction is related to pos action, false otherwise (it may be true even if promotionId is set)
   *        We store only flag to safe space (and to optimize queries, it is faster to query for flag value that existence of string).
   *        If targeted system should need to work with POS action code, reimport of all transaction is required.
   * @param motiveTypeId id of motive type code book, if external system does not use motive types, default (unknown) is set
   *        TODO attr will be removed when application starts to work with transactions using external ids
   * @param motiveTypeExtId reference to external id of motive type code book
   * @param amount number of units (product instances) in this transactions
   * @param saleValueWithVat the sale value of the whole transaction
   * @param vatValue the VAT of the sale value of the whole transaction
   * @param costValue cost of the whole transaction
   * @param stateFlags
   */
  function Transaction(id, externalId, productId, productExtId, siteId, siteExtId, date, dateFrom, dateTo, transactionTypeId, transactionTypeExtId, promotionId, promotionExtId, asPromotion, posAction, motiveTypeId, motiveTypeExtId, amount, saleValueWithVat, vatValue, costValue, stateFlags) {
    var _this;

    _classCallCheck(this, Transaction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Transaction).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.productId = productId;
    _this.productExtId = productExtId;
    _this.siteId = siteId;
    _this.siteExtId = siteExtId;
    _this.date = date;
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.transactionTypeId = transactionTypeId;
    _this.transactionTypeExtId = transactionTypeExtId;
    _this.promotionId = promotionId;
    _this.promotionExtId = promotionExtId;
    _this.asPromotion = asPromotion;
    _this.posAction = posAction;
    _this.motiveTypeId = motiveTypeId;
    _this.motiveTypeExtId = motiveTypeExtId;
    _this.amount = amount;
    _this.saleValueWithVat = saleValueWithVat;
    _this.vatValue = vatValue;
    _this.costValue = costValue;
    _this.stateFlags = stateFlags;
    return _this;
  }

  return Transaction;
}(StateDomainObject_1.StateDomainObject);

exports.Transaction = Transaction;

Transaction.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Transaction.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    productId: builder.str('productId'),
    productExtId: builder.str('productExtId'),
    siteId: builder.str('siteId'),
    siteExtId: builder.str('siteExtId'),
    date: builder.date('date', DateParser_1.DateParser.ISO_PATTERN),
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    transactionTypeId: builder.str('transactionTypeId'),
    transactionTypeExtId: builder.str('transactionTypeExtId'),
    promotionId: builder.opt(builder.str('promotionId')),
    promotionExtId: builder.opt(builder.str('promotionExtId')),
    asPromotion: builder.bool('asPromotion'),
    posAction: builder.bool('posAction'),
    motiveTypeId: builder.str('motiveTypeId'),
    motiveTypeExtId: builder.str('motiveTypeExtId'),
    amount: builder.bigNum('amount'),
    saleValueWithVat: builder.bigNum('saleValueWithVat'),
    vatValue: builder.bigNum('vatValue'),
    costValue: builder.bigNum('costValue'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();